import React from 'react';
import Card from 'components/Card';
import Flag from 'components/Flag';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
export function SearchWidgetCard(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    children = _ref.children,
    arrowSlot = _ref.arrowSlot;
  return /*#__PURE__*/React.createElement(Card, {
    p: "m",
    py: "s",
    overflow: "visible",
    position: "relative"
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Flag, {
    token: icon,
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    size: "small"
  }, title)), children), arrowSlot);
}